import { logger } from "../util/common";

export default {
    inheritAttrs: false,
    computed: {
        canPlayAudio() {
            return true;
        },
    },
    methods: {
    /**
     * Emits an action event
     * @param {*} action
     * @param {*} payload
     */
        emitAction(action, payload) {
            this.emitEvent("action", { action, ...payload });
        },
        /**
     * Emits an event
     * @param {*} name
     * @param {*} payload
     */
        emitEvent(name, payload) {
            this.$emit(name, payload);
        },
        /**
     * Logs info message to console
     * @param  {...any} args
     */
        logInfo(...args) {
            logger("info", ...args);
        },
        /**
     * Logs error message to console
     * @param  {...any} args
     */
        logError(...args) {
            logger("error", ...args);
        },
        markAsReadSafely(message) {
            return window.CometChat.markAsRead(message)
                .catch((error) => this.logError("Error marking message as read", error));
        },
        markAsDeliveredSafely(message) {
            return window.CometChat.markAsDelivered(message)
                .catch((error) => this.logError("Error marking message as delivered", error));
        },
        /**
     * Generates unique ID
     * @param {*} i
     */
        uid(i = 1) {
            return (
                `${i}` +
        Date.now().toString(36) +
        Math.random().toString(36).substring(2)
            );
        },
    },
};
